var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tenants-settings-cont" },
    [
      _c("section-title", {
        attrs: { title: "Tenants", icon: "fas fa-address-card" },
      }),
      _c(
        "div",
        { staticClass: "tenants-cont" },
        [
          !_vm.isLoadingData && _vm.getTenants.length < 1
            ? [
                _c("div", { staticClass: "no-results mt-4" }, [
                  _vm._v("No tenants found"),
                ]),
              ]
            : _vm._e(),
          !_vm.isLoadingData &&
          _vm.getTenants.length > 0 &&
          _vm.getTenantsTree.length > 0
            ? [
                _c(
                  "div",
                  { staticClass: "tenants-tree-cont" },
                  _vm._l(
                    _vm.getTenantsTree,
                    function (tenantNodeItem, tenantNodeIndex) {
                      return _c(
                        "div",
                        {
                          key: `tenant-node-key-${tenantNodeIndex}`,
                          staticClass: "text-color tenant-wrap",
                        },
                        [
                          _c("div", { staticClass: "tenant-row" }, [
                            _c("div", { staticClass: "tenant-item node" }, [
                              _c(
                                "div",
                                { staticClass: "tenant-item node__name" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("far fa-building")]
                                  ),
                                  _vm._v(
                                    " " + _vm._s(tenantNodeItem.name) + " "
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "tenant-item node__action" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          small: "",
                                                          rounded: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editTenantHandler(
                                                              tenantNodeItem.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          "x-small": "",
                                                        },
                                                      },
                                                      [_vm._v(" far fa-edit ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Edit")])]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              { staticClass: "tenant-channels" },
                              [
                                _c("channels-panel", {
                                  attrs: {
                                    loading: _vm.assigning,
                                    enabled: tenantNodeItem.channels,
                                  },
                                  on: {
                                    toggle: (channelDataArg) =>
                                      _vm.enableChannel(
                                        channelDataArg,
                                        tenantNodeItem
                                      ),
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          !!tenantNodeItem.children &&
                          tenantNodeItem.children.length > 0
                            ? _vm._l(
                                tenantNodeItem.children,
                                function (childTenantItem, childTenantIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: `child-tenant-key-${childTenantIndex}`,
                                      staticClass: "tenant-row",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "tenant-item child" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tenant-item child__name",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: { small: "" },
                                                },
                                                [_vm._v("fas fa-user-tie")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(childTenantItem.name) +
                                                  " "
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "tenant-item child__action",
                                            },
                                            [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { bottom: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function ({
                                                          on,
                                                          attrs,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                      rounded:
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.editTenantHandler(
                                                                            childTenantItem.id
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              ),
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      "x-small":
                                                                        "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " far fa-edit "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [_c("span", [_vm._v("Edit")])]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "tenant-channels" },
                                        [
                                          _c("channels-panel", {
                                            attrs: {
                                              loading: _vm.assigning,
                                              enabled: childTenantItem.channels,
                                            },
                                            on: {
                                              toggle: (channelDataArg) =>
                                                _vm.enableChannel(
                                                  channelDataArg,
                                                  childTenantItem
                                                ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }
                  ),
                  0
                ),
              ]
            : _vm._e(),
          _vm.isAdmin === true
            ? _c(
                "v-btn",
                {
                  style: { bottom: "20px" },
                  attrs: {
                    fab: "",
                    bottom: "",
                    right: "",
                    color: _vm.$vuetify.theme.dark ? "#685AA1" : "primary",
                    dark: "",
                    fixed: "",
                  },
                  on: { click: _vm.addNewTenantHandler },
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              )
            : _vm._e(),
          _c("tenant-editor", {
            attrs: {
              "show-dialog": _vm.showTenantEditor,
              "tenants-list": _vm.tenantsList,
              "tenant-data": _vm.tenantData,
              loading: _vm.saving,
            },
            on: { save: _vm.saveTenant, close: _vm.closeEditorHandler },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }